import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { ImpersonationMode } from "@/components/ImpersonationMode";
import { initSentry } from "@/lib/sentry";
import { initializeUsageTracking } from "@/services/usage-event-handlers";

// Initialize Sentry for error tracking
initSentry();

// Initialize event-driven usage tracking
initializeUsageTracking();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <ImpersonationMode />
      <App />
    </ErrorBoundary>
  </StrictMode>
);
